import { createBrowserRouter } from 'react-router-dom';

import { Chat } from '../routes/Chat';
import { Dashboard } from '../routes/Dashboard';
import { DeckDetail } from '../routes/DeckDetail';
import { Decks } from '../routes/Decks';
import { Logs } from '../routes/Logs';
import { MatchDetail } from '../routes/MatchDetail';
import { Matches } from '../routes/Matches';
import { Meta } from '../routes/Meta';
import { NotFound } from '../routes/NotFound';
import { Settings } from '../routes/Settings';

import { AppShell } from './AppShell';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'decks', element: <Decks /> },
      { path: 'decks/:id', element: <DeckDetail /> },
      { path: 'matches', element: <Matches /> },
      { path: 'matches/:id', element: <MatchDetail /> },
      { path: 'meta', element: <Meta /> },
      { path: 'meta/:format', element: <Meta /> },
      { path: 'chat', element: <Chat /> },
      { path: 'logs', element: <Logs /> },
      { path: 'settings', element: <Settings /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
